module.exports = __webpack_public_path__ + "img/gld_gbt71_1985.prt.4c148e86.jpg";